import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import common from './modules/common'
import logs from './modules/logs'
import tags from './modules/tags'
import data from './modules/data'
import cancelreq from './modules/cancelreq'
import getters from './getters'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    user,
    common,
    logs,
    tags,
    data,
    cancelreq,
  },
  getters,
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js